<template>
  <fade-transition>
    <b-alert
      :show="dismissCountDown"
      dismissible
      :variant="type"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      class="position-fixed fixed-bottom m-0 rounded-0"
    >
        <slot></slot>
        <b-progress
            :variant="type"
            :max="dismissSecs"
            :value="dismissCountDown"
            height="4px"
        ></b-progress>
    </b-alert>
  </fade-transition>
</template>
<script>
import { FadeTransition } from 'vue2-transitions';

export default {
  name: 'countdown-alert',
  components: {
    FadeTransition
  },
  props: {
    type: {
      type: String,
      default: 'success',
      description: 'Alert type'
    },
    icon: {
      type: String,
      default: '',
      description: 'Alert icon to display'
    }
  },
  data() {
    return {
        visible: true,
        dismissSecs: 3,
        dismissCountDown: 3
    };
  },
  methods: {
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
        if(this.dismissCountDown == 0) {
            this.$emit('close', true);
            this.dismissCountDown = 3
        }
      },
  }
};
</script>
